import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { WalletService } from "../api";

export const actionGetListWallet = createAsyncThunk(
  "wallet/list_wallet",
  async (_, { rejectWithValue }) => {
    try {
      const res = await WalletService.doListWallet();

      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionCreateWallet = createAsyncThunk(
  "wallet/create-wallet",
  async (data) => {
    try {
      const res = await WalletService.doCreateWallet(data);

      if (res.status === 200) {
        toast.success(res.data?.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return [];
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return error.response?.data;
    }
  }
);

const walletSlice = createSlice({
  name: "wallet",
  initialState: {
    listWallet: {
      loading: false,
      data: null,
      error: "",
    },
    createWallet: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // listWallet
      .addCase(actionGetListWallet.pending, (state) => {
        state.listWallet.loading = true;
      })
      .addCase(actionGetListWallet.fulfilled, (state, action) => {
        state.listWallet.loading = false;
        state.listWallet.data = action.payload;
      })
      .addCase(actionGetListWallet.rejected, (state, action) => {
        state.listWallet.loading = false;
        state.listWallet.data = action.payload;
        state.listWallet.error = action.error.message || "Something went wrong";
      })
      .addCase(actionCreateWallet.pending, (state) => {
        state.createWallet.loading = true;
      })
      .addCase(actionCreateWallet.fulfilled, (state, action) => {
        state.createWallet.loading = false;
        state.createWallet.data = action.payload;
      })
      .addCase(actionCreateWallet.rejected, (state, action) => {
        state.createWallet.loading = false;
        state.createWallet.data = action.payload;
        state.createWallet.error = {};
      });
  },
});

export default walletSlice.reducer;
export const { actions, reducer } = walletSlice;
